//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import ImageRowWidget from "../../General/LandingPage/ImageRowWidget/ImageRowWidget";
//  Config
import VocabPatientContent from "../../../../ConfigFiles/multilingual/VocabPatientContent";
//  ----------      START   IMPORT  BLOCK       ----------


export const getProUserManualContent = (lan) => {
  return [
    {
      id: VocabPatientContent.FAQ_section_id[lan],
      title: VocabPatientContent.FAQ_section_title[lan],
      chapters: [
        {
          id: VocabPatientContent.FAQ_Q1_id[lan],
          title: VocabPatientContent.FAQ_Q1_title[lan],
          body: VocabPatientContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: VocabPatientContent.FAQ_Q2_id[lan],
          title: VocabPatientContent.FAQ_Q2_title[lan],
          body: VocabPatientContent.FAQ_Q2_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
                {
          id: VocabPatientContent.FAQ_Q3_id[lan],
          title: VocabPatientContent.FAQ_Q3_title[lan],
          body: VocabPatientContent.FAQ_Q3_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
                {
          id: VocabPatientContent.FAQ_Q4_id[lan],
          title: VocabPatientContent.FAQ_Q4_title[lan],
          body: VocabPatientContent.FAQ_Q4_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabPatientContent.help_section_id[lan],
      title: VocabPatientContent.help_section_title[lan],
      chapters: [
        {
          id: VocabPatientContent.FAQ_Q1_id[lan],
          title: VocabPatientContent.FAQ_Q1_title[lan],
          body: VocabPatientContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: VocabPatientContent.FAQ_Q2_id[lan],
          title: VocabPatientContent.FAQ_Q2_title[lan],
          body: VocabPatientContent.FAQ_Q2_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabPatientContent.privacy_section_id[lan],
      title: VocabPatientContent.privacy_section_title[lan],
      chapters: [
        {
          id: VocabPatientContent.FAQ_Q1_id[lan],
          title: VocabPatientContent.FAQ_Q1_title[lan],
          body: VocabPatientContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: VocabPatientContent.FAQ_Q2_id[lan],
          title: VocabPatientContent.FAQ_Q2_title[lan],
          body: VocabPatientContent.FAQ_Q2_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabPatientContent.pricing_section_id[lan],
      title: VocabPatientContent.pricing_section_title[lan],
      chapters: [
        {
          id: VocabPatientContent.FAQ_Q1_id[lan],
          title: VocabPatientContent.FAQ_Q1_title[lan],
          body: VocabPatientContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: VocabPatientContent.FAQ_Q2_id[lan],
          title: VocabPatientContent.FAQ_Q2_title[lan],
          body: VocabPatientContent.FAQ_Q2_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
      ],
    }
  ];
};
